// components/AulaCapacityChip.tsx
import { Chip } from "@mui/material";

export function AulaCapacityChip({ capacidad, cat }: { capacidad: number; cat: "S" | "M" | "L" }) {
  const label = `${capacidad} • ${cat}`;
  return <Chip size="small" label={label} variant="outlined" />;
}
